import {Injectable} from "@angular/core";
import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from "@angular/router";
import {Observable} from "rxjs";
import {DbResponse} from "../../shared/interceptors/db-response";
import {UserSubscription} from '../../user/user-subscription';
import {WorkspaceService} from "../workspace.service";
import { filter, first } from "rxjs";

@Injectable()
export class UserPaymentMethodResolver implements Resolve<UserSubscription|null> {

  constructor(
    private _workspaceService: WorkspaceService,
  ) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any>|Promise<any>|any {
    return new Promise((resolve: Function, reject: Function): void => {
      this._workspaceService.getActivePaymentMethod().pipe(
        filter((response: DbResponse): boolean => !!response),
        first()
      ).subscribe((response: DbResponse): void => {
          if (response.success && response.data) {
            resolve(response.data);
          }
          else {
            resolve(null);
          }
        });
    });
  }
}
